var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('top-bar',{on:{"logo-click":_vm.onLogoClick}},[(_vm.idToken)?_c('user-toolbar',{attrs:{"name":_vm.idToken.name,"email":_vm.idToken.email,"role":"Administrator"},on:{"logout-click":_vm.onLogoutClick}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }